export { default as ContentSlotMain } from '../HomePage/ContentSlotMain'
export { default as YMMEControl } from '../VehicleConfigurator/components/YMMEControl'
export { default as ValueProposition } from '../HomePage/ValueProposition/index'
export { default as MainHeadlineContent } from '../HomePage/MainHeadlineContent/index'
export { default as PromotionBannerSpotlight } from '../HomePage/PromotionBannerSpotlight'
export { default as ScrollablePromotionBannerSpotlight } from '../HomePage/ScrollablePromotionBannerSpotlight'
export { TeaserHtmlContentBlock } from '../HomePage'
